export default __webpack_public_path__ + "static/media/2017.18064e1f.pdf";